import React from 'react'

const Bestseller = () => {
  return (
    <div>Bestseller</div>
  )
}

export default Bestseller